import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Home } from "lucide-react";

export default function HomeButton() {
    const location = useLocation();
    const navigate = useNavigate();
    if (location.pathname === "/") return null;
    return (
        <button
            onClick={() => navigate("/")}
            data-testid="return-home-btn"
            aria-label="Return to home"
            className="print:hidden fixed bottom-5 left-5 z-[60] inline-flex items-center gap-2 rounded-full bg-[#4C1D95] text-white shadow-lg shadow-black/20 h-11 px-5 text-sm font-medium transition-all duration-200 hover:bg-[#2E1065] hover:-translate-y-0.5"
        >
            <Home className="w-4 h-4" /> Home
        </button>
    );
}
